<template>
  <div v-if="is_authenticated">
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on">Меню</v-btn>
      </template>
      <v-list>
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>{{ abiturient.last_name }} {{ abiturient.first_name }}</v-list-item-title>
            <v-list-item-subtitle>{{ abiturient.user.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link v-if="user.is_abit && !abiturient.personal_data_completed" :to="{name: 'profile_personal'}">
          <v-list-item-title>Персональные данные</v-list-item-title>
        </v-list-item>
        <v-list-item link v-else-if="user.is_abit && abiturient.personal_data_completed"
                     :to="{name: 'profile_application_list'}">
          <v-list-item-title>Мои заявления</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="{name: 'profile_settings'}">
          <v-list-item-title>Настройки</v-list-item-title>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-item link v-if="user.is_staff" :to="{name: 'operator'}">
          <v-list-item-title>Список новых заявлений</v-list-item-title>
        </v-list-item>
        <v-list-item link v-if="user.is_staff" :to="{name: 'operator_profile'}">
          <v-list-item-title>Личный кабинет оператора</v-list-item-title>
        </v-list-item>
        <v-list-item link v-if="user.is_superuser" :to="{name: 'admin'}">
          <v-list-item-title>Личный кабинет Администратора</v-list-item-title>
        </v-list-item>
        <v-list-item link v-if="user.is_staff" :to="{name: 'operator_protector'}">
          <v-list-item-title>Протекторат</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item link :to="{name: 'logout'}">
          <v-list-item-title>Выход</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
  <div v-else>
    <v-btn text large tile :to="{name: 'login'}">Войти</v-btn>
    <v-btn color="warning" dark tile large :to="{name: 'registration'}">
      <span class="d-sm-none">Заявление</span>
      <span class="d-none d-sm-flex">Подать заявление ONLINE</span>
    </v-btn>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "UserMenu",
  computed: {
    ...mapGetters("auth", ["is_authenticated", "user"]),
    ...mapGetters("abiturient", ["abiturient"])
  }
}
</script>

<style scoped>

</style>
